<h2 matDialogTitle class="mat-h2">Get Link</h2>

<mat-dialog-content>
  <div class="text-ad-details">
    <div class="top-line">
      <span class="ad-title">{{merchantAd.merchant.merchant_name}}: <i>{{merchantAd.ad_title}}</i></span>
      <span style="float:right;" *ngIf="merchantAd.ad_type === 'banner'">
        <a mat-icon-button color="accent" matTooltip="Ad Image Link" target='_blank' el="noopener" [href]="merchantAd.image_url"><mat-icon>link</mat-icon></a>
        <button mat-icon-button color="accent" matTooltip="Download" (click)="onDownloadClick()"><mat-icon>download</mat-icon></button>
      </span>
    </div>
    <br>

    <ng-container *ngIf="merchantAd.ad_type === 'banner'">
      <img [ngSrc]="merchantAd.image_url" width="{{merchantAd.image_width}}" height="{{merchantAd.image_height}}">
      <div class="wash-out" style="text-align: center">Banner {{merchantAd.image_width}}x{{merchantAd.image_height}}</div>
    </ng-container>

    <ng-container *ngIf="merchantAd.ad_type === 'text'">
      <div>{{merchantAd.link_text}}</div>
      <div class="wash-out">Text Ad</div>
    </ng-container>
  </div>
  <br>

  <mat-radio-group [formControl]="controls.linkType">
    <mat-radio-button *ngFor="let linkTypeEntry of linkTypeEntries" [value]="linkTypeEntry[0]">{{linkTypeEntry[1].label}}</mat-radio-button>
  </mat-radio-group>
  <br>
  <br>

  <div class="tracking-link-container">
    <mat-form-field appearance="fill" style="flex: 1">
      <mat-label>{{linkTypeMap[controls.linkType.value].linkLabel}}</mat-label>
      <input matInput readonly [value]="trackingLink$ | async" #trackingLinkInput>
      <mat-hint *ngIf="controls.linkType.value === 'dynamicJavaScript'">Automatically changes with merchant updates</mat-hint>
      <mat-hint align="end">chars {{trackingLinkInput.value?.length || 0}}</mat-hint>
    </mat-form-field>
  </div>

  <div [@.disabled]="disableAnimation">
    <mat-expansion-panel [expanded]='false'>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Tracking Link Settings
        </mat-panel-title>
      </mat-expansion-panel-header>

        <mat-form-field floatLabel="always">
          <mat-label>Affiliate Website</mat-label>
          <mat-select [formControl]="controls.affiliateWebsite">
            <mat-option *ngFor="let affiliateWebsite of affiliateWebsites$ | async" [value]="affiliateWebsite">
              {{affiliateWebsite.affiliateWebsiteUrlStripped}}
            </mat-option>
          </mat-select>
          <mat-hint>Select the website to associate clicks to</mat-hint>
        </mat-form-field>

        <mat-form-field floatLabel="always">
          <mat-label>Custom Tracking Code</mat-label>
          <input matInput placeholder="Enter Text (Optional)" [formControl]="controls.customTrackingCode">
          <mat-hint>Click parameter associated to this link</mat-hint>
          <mat-error>{{controls.customTrackingCode.errors | validationMessage}}</mat-error>
        </mat-form-field>

      <div *ngIf="controls.linkType.value !== 'link'">
        <mat-checkbox style="flex: 1 1 204px;" [formControl]="controls.openLinkInNewWindow">Open Link in New Window</mat-checkbox>
      </div>
    </mat-expansion-panel>
  </div>
  <br>
</mat-dialog-content>

<mat-dialog-actions class="actions-with-social-shares">
  <div class="copy-button-group">
    <button mat-button matDialogClose color="accent">Cancel</button>
    <button mat-raised-button color="primary" cdkFocusInitial (click)="onCopyClick(trackingLinkInput.value)" [disabled]="controls.customTrackingCode.invalid">Copy</button>
  </div>
</mat-dialog-actions>
